import { IonPage, IonText } from '@ionic/react';
import { logEvent, setScreenName } from '../../../utils/Analytics';
import { EVENT, SCREEN } from '../../../utils/constants.analytics';
import React, { useEffect, useState } from 'react';
import './SupportPage.scss';
import MenuDetailsPage from './menuDetailsPage';

export const Support: React.FC<any> = (props: any) => {
  const { menuItemDetails } = props;
  const menuItems = (menuItemDetails && menuItemDetails.menuItems) || [];
  const menuEntries = (menuItemDetails && menuItemDetails.menuEntries) || []
  let menuHeading: any = [];
  menuItems && menuItems.map((heading: any) => {
    menuHeading.push(heading.title);
  });
  const [subHeading, setSubHeading] = useState([]);
  const [segment, setSegment] = useState<string>(menuHeading[0]);
  const [subSegment, setSubSegment] = useState<string>(subHeading[0]);;
  const [subMenuDetails, setSubMenuDetails] = useState<any>();
  useEffect(() => {
    let subMenuHeading: any = [];
    let menuDetails = menuItems && menuItems.filter((heading: any) => heading.title === segment);
    menuDetails = menuDetails && menuDetails[0] && menuDetails[0].group;
    menuDetails && menuDetails.map((data: any) => {
      subMenuHeading.push(data.menuItem);
    })
    setSubHeading(subMenuHeading);
  }, [segment]);

  useEffect(() => {
    setSubSegment(subHeading[0])
  }, [subHeading]);
  useEffect(() => {
    let menuDetails = menuItems && menuItems.filter((heading: any) => heading.title === segment);
    menuDetails = menuDetails && menuDetails[0] && menuDetails[0].group;
    const selectedSubMenu = menuDetails && menuDetails.filter((details: any) => details.menuItem === subSegment);
    let uid = selectedSubMenu && selectedSubMenu[0] && selectedSubMenu[0].uid;
    let details = menuEntries.filter((data: any) => {
      return data.uid == uid
    });
    setSubMenuDetails(details && details[0]);
  }, [subSegment])

  useEffect(() => {
    // Analytics implementation
    setScreenName("screen_menu");
    logEvent(EVENT.SV_MORE_MENU, {
      screen: SCREEN.MORE_MENU,
      carrierId: props?.userDetails?.memberDetailsResponse?.member?.carrierId
    });

    logEvent(EVENT.SV_MORE_FAQ, {
      screen: SCREEN.MORE_FAQ
    });

  }, []);

  const handleTabChange = (data: any) => {
    setSegment(data);
  }
  const getSubMenu = (data: any) => {
    setSubSegment(data);
  }

  return (
    <IonPage className="ion-page desktop-page sni-support-page" data-testid="supportPage">
      <div>
        {menuHeading.map((name: string, index:any) => (
          <IonText key={index} class={`main-heading ${name === segment ? 'selected_menu' : ''}`} data-testid="support-main-heading" onClick={() => handleTabChange(name)}>{name}</IonText>
        ))}
        <div className="sni-support-sub-page">
          {subHeading.length > 1 ? <>
            {subHeading.map((data: string, index:any) => (
              <IonText key={index} class={`sub-heading ion-margin-bottom ${data === subSegment ? 'selected_menu' : ''}`} onClick={() => getSubMenu(data)}>
                {data === 'Frequently Asked Questions' ? "FAQ" : data}
              </IonText>
            ))}</> : null
          }
          <div className="sni-support-content">
            <MenuDetailsPage subMenuDetails={subMenuDetails} {...props} />
          </div>
        </div>
      </div>
    </IonPage>
  );
}